import { Attributes, List, LookupBase } from '@singularsystems/neo-core';
import UtilisationLookup from '../IssuerInvestments/Lookups/UtilisationLookup';

export default class DashboardEntityLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    @Attributes.ChildList(UtilisationLookup)
    public utilisation = new List(UtilisationLookup);

    public entityName: string = "";

    // Client only properties / methods
}